import template from './adpPeriodIndicator.html';
import controller from './adpPeriodIndicator.controller';
import './adpPeriodIndicator.less';

let adpPeriodIndicatorComponent = {
  restrict: 'E',
  bindings: {
    items: '<'
  },
  template,
  controller
};

export default adpPeriodIndicatorComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpPeriodIndicator/adpPeriodIndicator.component.js